module.exports = __webpack_public_path__ + "img/accessory_item_04.e7c179b1.svg";